'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface MindboxPageViewProps<P> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: (params: P) => Promise<any>;
  params: P;
}

export function MindboxPageView<P>({
  action,
  params
}: MindboxPageViewProps<P>) {
  const pathname = usePathname();

  useEffect(() => {
    const t = setTimeout(() => {
      action(params);
    }, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
